"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProviders = exports.createTokenProvider = exports.createEndpointsProvider = void 0;
function createEndpointsProvider() {
    return function () {
        return Promise.resolve({
            webgate: 'https://www.spotify.com/api/',
            webapi: 'https://api.spotify.com',
        });
    };
}
exports.createEndpointsProvider = createEndpointsProvider;
function createTokenProvider() {
    return function () { return Promise.resolve('NOT_A_TOKEN'); };
}
exports.createTokenProvider = createTokenProvider;
function createProviders() {
    return {
        endpoints: createEndpointsProvider(),
        token: createTokenProvider(),
    };
}
exports.createProviders = createProviders;
//# sourceMappingURL=index.js.map